import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { Medium } from 'streamr-ui/css/consts'
import LogoNewToken from './assets/LogoNewToken.svg'
import Link from '~shared/Link'
import urls from '~utils/urls'

const TokenIcon = styled.div`
    img {
        display: block;
        width: 20px;
        height: 20px;
    }
`

const Text = styled.div`
    font-weight: ${Medium};
    font-size: 12px;
    line-height: 30px;
    color: #0C009A;
    white-space: nowrap;
`

const ArrowIcon = styled.div``

const Arrow = () => (
    <svg width="13" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            transform="matrix(1 0 0 -1 0 4.5)"
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            d="M.75-.75h10.5"
        />
        <path
            d="M7.398 9.485l4.243-4.242L7.398 1"
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const UnstyledBadge = forwardRef(function UnstyledBadge({ className }, ref) {
    return (
        <Link
            className={className}
            href={urls.project.tokenMigration}
            noDecoration
            noHover
            ref={ref}
        >
            <TokenIcon>
                <img src={LogoNewToken} alt="DATA" />
            </TokenIcon>
            <Text>
                Migrate to the new DATA token
            </Text>
            <ArrowIcon>
                <Arrow />
            </ArrowIcon>
        </Link>
    )
})

const Badge = styled(UnstyledBadge)`
    position: relative;
    background-color: #FAFAFA;
    border-radius: 4px;
    height: 48px;
    padding: 0 20px 0 18px;
    display: flex;
    align-items: center;
    width: fit-content;

    ${TokenIcon} + ${Text} {
        margin-left: 1rem;
    }

    ${Text} + ${ArrowIcon} {
        margin-left: 1rem;
    }

    ::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
        transition: opacity 300ms ease-in-out;
        top: 0;
        left: 0;
        opacity: 0;
    }

    :hover {
        ::after {
            opacity: 1;
        }
    }
`

export default Badge
